import {Component, inject} from '@angular/core';
import {LayoutService} from './service/app.layout.service';
import {APP_CONFIG} from "../app-config";

@Component({
    selector: 'app-footer',
    templateUrl: './app.footer.component.html',
})
export class AppFooterComponent {

    appConfig = inject(APP_CONFIG)
    constructor(public layoutService: LayoutService) {
    }

    get logo() {
        return this.layoutService.config().colorScheme === 'light'
            ? 'dark'
            : 'white';
    }
}
